import { Checkbox, styled, Text, TextTag, TokenTextAppearance } from "@volkswagen-onehub/components-core";
import React from "react";
import Skeleton from "react-loading-skeleton";
import useFiltersQuery from "../../api/use-filters-query";
import { useSelectedFilterStore } from '../../store/filtersv2';
import { getLang, getTranslations } from "../../translations";
import { BasicFilterOption, FiltersResponse, FiltersResponseKey, Language } from "../../types";
import { ResponseSelector } from "../../types/globalapi/response-selector";
import { useFeatureServices } from "../../use-feature-services";
import { getSingleSelectedDealer } from "../../utils/get-single-selected-dealer";
import { createConfiguration, createConstantData, createPartner } from "../../utils/get-tracking-event-data";

const Wrapper = styled.div`
  margin: 12px 0px 0px;
`;

export const InStockOption = () => {

  const lang = getLang();

  const getInStockOption: ResponseSelector<FiltersResponse, Omit<BasicFilterOption, "value">[]> = res => res[FiltersResponseKey.IN_STOCK];
  const { isLoading, data: in_stock } = useFiltersQuery<FiltersResponse, Omit<BasicFilterOption, "value">[]>({select: getInStockOption});
  const { selected, selectFilter } = useSelectedFilterStore();

  // for onclick tracking
  const { tracking } = useFeatureServices();
  const labels = getTranslations(Language.EN);
  const partner = getSingleSelectedDealer(); // nts may need to be updated

  const handleClick = (e: React.SyntheticEvent<HTMLInputElement>) => {
    selectFilter("in_stock", e.currentTarget.checked);

    if (e.currentTarget.checked) {
      tracking.track("VWBasic_FilterSelect_Click", {
        ...createConstantData(),
        configuration: createConfiguration(),
        partner: createPartner(partner),
        link: {
          url: window.location.href,
          name: labels.in_stock
        },
        filter: {
          type: 'single_value',
          name: labels.in_stock,
          values: e.currentTarget.checked,
        }
      });
    }
  };

  return (
    isLoading ?
      <Skeleton />
    : <> {
      (in_stock as BasicFilterOption[]).map((item, i) => (
        <Wrapper key={`in-stock-${i}`}>
          <Checkbox
            value={String(selected.in_stock)}
            onClick={handleClick}
            label={<Text tag={TextTag.span} appearance={TokenTextAppearance.copy200}>{ item.label[lang] }</Text>}
            checked={selected.in_stock}
          />
        </Wrapper>
      ))
    } </>
  );
};
